import { orderService } from '../../api'
import common from '../../common/common.js'
import router from './../../router'

let menu = JSON.parse(sessionStorage.getItem('menuList') || '[]')
let userType = sessionStorage.getItem('userType') || ''
console.log(menu)
export default {
  // 是否使用命名空间
  namespaced: true,
  state: {
    menuList: menu,
    userType: userType
  },
  getters: {},
  mutations: {
    SET_USER(state, payload) {
      state.menuList = payload
    },
    SET_USERTYPE(state, payload) {
      state.userType = payload
    }
  },
  actions: {
    async UT_LOGIN({ commit }, payload) {
      console.log(payload)
      let data = await orderService.utLogin(payload)
      console.log(data)
      if (data.code === 0) {
        sessionStorage.setItem('loginSuccess', true)
        sessionStorage.setItem('token', data.data.token)
        sessionStorage.setItem('fullName', data.data.fullName)
        sessionStorage.setItem('areaCode', data.data.areaCode)
        sessionStorage.setItem('areaName', data.data.areaName)
        sessionStorage.setItem('menuList', JSON.stringify(data.data.menuList))
        sessionStorage.setItem('userType', data.data.userType)
        commit('SET_USER', data.data.menuList)
        commit('SET_USERTYPE', data.data.userType)
        router.push('/home')
      }
    }
  },
  modules: {}
}
